
import React, { useState } from "react";
import { Row, Col, Card, message } from "antd";
import { MailOutlined, PhoneOutlined, UserOutlined, BookOutlined, MessageOutlined, SendOutlined, StarOutlined, TrophyOutlined, CheckCircleOutlined } from "@ant-design/icons";
import courseService from "../../services/course.service";

const BecomeInstructor = () => {
    // État pour le formulaire d'instructeur
    const EMPTY_INSTRUCTOR = { 
        fullName: "", 
        email: "", 
        phone: "", 
        subject: "", 
        message: "" 
    };
    
    const [instructorForm, setInstructorForm] = useState(EMPTY_INSTRUCTOR);
    const [instructorErrors, setInstructorErrors] = useState({});
    const [instructorLoading, setInstructorLoading] = useState(false);
    const [instructorSuccess, setInstructorSuccess] = useState(false);

    const update = (k, v) => setInstructorForm((p) => ({ ...p, [k]: v }));

    // Validation du formulaire - MISE À JOUR avec validation de longueur du message
    const validateInstructor = () => {
        const e = {};
        if (!instructorForm.fullName.trim()) e.fullName = "Nom complet requis";
        if (!instructorForm.email.trim()) e.email = "Email requis";
        else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(instructorForm.email)) e.email = "Email invalide";
        if (!instructorForm.phone.trim()) e.phone = "Téléphone requis";
        if (!instructorForm.subject.trim()) e.subject = "Sujet requis";
        
        // VALIDATION MISE À JOUR pour le message
        if (!instructorForm.message.trim()) {
            e.message = "Message requis";
        } else if (instructorForm.message.trim().length < 50) {
            e.message = `Le message doit contenir au moins 50 caractères (actuellement ${instructorForm.message.trim().length})`;
        } else if (instructorForm.message.trim().length > 2000) {
            e.message = `Le message ne peut pas dépasser 2000 caractères (actuellement ${instructorForm.message.trim().length})`;
        }
        
        setInstructorErrors(e);
        return Object.keys(e).length === 0;
    };

    // Soumission du formulaire
    const submitInstructor = async () => {
        if (!validateInstructor()) return;
        setInstructorLoading(true);
        setInstructorSuccess(false);
        
        try {
            await courseService.createInstructorRequest({
                fullName: instructorForm.fullName,
                email: instructorForm.email,
                phone: instructorForm.phone,
                subject: instructorForm.subject,
                message: instructorForm.message
            });
            
            setInstructorSuccess(true);
            setInstructorForm(EMPTY_INSTRUCTOR);
            setInstructorErrors({});
            message.success("✅ Votre demande d'instructeur a été envoyée avec succès !");
        } catch (e) {
            console.error(e);
            // Gestion améliorée des erreurs backend
            if (e.response && e.response.data && e.response.data.error) {
                message.error(`Erreur: ${e.response.data.error}`);
            } else {
                message.error("Erreur lors de l'envoi. Réessayez.");
            }
        } finally {
            setInstructorLoading(false);
        }
    };

    const inputStyle = {
        width: "100%",
        padding: "12px 16px",
        borderRadius: "8px",
        border: "2px solid #e1e8ed",
        fontSize: "14px",
        transition: "all 0.3s ease",
        fontFamily: "inherit"
    };

    const labelStyle = {
        display: "block",
        fontSize: "14px",
        fontWeight: "600",
        marginBottom: "8px",
        color: "#2c3e50"
    };

    const errorStyle = {
        color: "#e74c3c",
        fontSize: "12px",
        marginTop: "6px",
        fontWeight: "500"
    };

    return (
        <div style={{ 
            background: "linear-gradient(135deg, #a8e6cf 0%, #88d8a3 50%, #52b788 100%)",
            minHeight: "100vh",
            padding: "40px 20px"
        }}>
            {/* En-tête */}
            <div style={{ textAlign: "center", marginBottom: "50px" }}>
                <h1 style={{ 
                    color: "white", 
                    fontSize: "42px", 
                    fontWeight: "700",
                    marginBottom: "15px",
                    textShadow: "0 2px 4px rgba(0,0,0,0.3)"
                }}>
                    🎓 Devenir Formateur
                </h1>
                <p style={{ 
                    color: "rgba(255,255,255,0.9)", 
                    fontSize: "18px",
                    maxWidth: "600px",
                    margin: "0 auto",
                    lineHeight: "1.6"
                }}>
                    Rejoignez notre équipe de formateurs experts et partagez vos connaissances avec des milliers d'apprenants
                </p>
            </div>

            <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
                <Row gutter={[32, 32]} align="top">
                    {/* Informations sur le Programme */}
                    <Col xs={24} lg={10}>
                        <Card
                            style={{ 
                                borderRadius: "20px", 
                                boxShadow: "0 20px 60px rgba(0,0,0,0.15)",
                                border: "none",
                                overflow: "hidden",
                                height: "100%"
                            }}
                        >
                            <div style={{
                                background: "linear-gradient(135deg, #52b788 0%, #2d6a4f 100%)",
                                margin: "-24px -24px 30px -24px",
                                padding: "30px 24px",
                                textAlign: "center"
                            }}>
                                <h2 style={{ 
                                    color: "white", 
                                    fontSize: "24px", 
                                    fontWeight: "600",
                                    margin: "0",
                                    textShadow: "0 2px 4px rgba(0,0,0,0.2)"
                                }}>
                                    🌟 Pourquoi Nous Rejoindre
                                </h2>
                            </div>

                            <div style={{ padding: "0 10px" }}>
                                {/* Avantage 1 */}
                                <div style={{ 
                                    display: "flex", 
                                    alignItems: "center", 
                                    marginBottom: "25px",
                                    padding: "15px",
                                    background: "linear-gradient(135deg, #ffeaa7 0%, #fdcb6e 100%)",
                                    borderRadius: "12px",
                                    boxShadow: "0 4px 15px rgba(253, 203, 110, 0.3)"
                                }}>
                                    <TrophyOutlined style={{ 
                                        fontSize: "24px", 
                                        color: "#f39c12", 
                                        marginRight: "15px",
                                        background: "white",
                                        padding: "8px",
                                        borderRadius: "50%"
                                    }} />
                                    <div>
                                        <div style={{ fontWeight: "600", color: "#2d3436", fontSize: "16px" }}>Expertise Reconnue</div>
                                        <div style={{ color: "#636e72", fontSize: "15px" }}>Partagez vos compétences et devenez un expert reconnu</div>
                                    </div>
                                </div>

                                {/* Avantage 2 */}
                                <div style={{ 
                                    display: "flex", 
                                    alignItems: "center", 
                                    marginBottom: "25px",
                                    padding: "15px",
                                    background: "linear-gradient(135deg, #74b9ff 0%, #0984e3 100%)",
                                    borderRadius: "12px",
                                    boxShadow: "0 4px 15px rgba(116, 185, 255, 0.3)"
                                }}>
                                    <StarOutlined style={{ 
                                        fontSize: "24px", 
                                        color: "#0984e3", 
                                        marginRight: "15px",
                                        background: "white",
                                        padding: "8px",
                                        borderRadius: "50%"
                                    }} />
                                    <div>
                                        <div style={{ fontWeight: "600", color: "white", fontSize: "16px" }}>Impact Éducatif</div>
                                        <div style={{ color: "rgba(255,255,255,0.9)", fontSize: "15px" }}>Formez la prochaine génération de professionnels</div>
                                    </div>
                                </div>

                                {/* Avantage 3 */}
                                <div style={{ 
                                    display: "flex", 
                                    alignItems: "center", 
                                    marginBottom: "25px",
                                    padding: "15px",
                                    background: "linear-gradient(135deg, #fd79a8 0%, #e84393 100%)",
                                    borderRadius: "12px",
                                    boxShadow: "0 4px 15px rgba(232, 67, 147, 0.3)"
                                }}>
                                    <BookOutlined style={{ 
                                        fontSize: "24px", 
                                        color: "#e84393", 
                                        marginRight: "15px",
                                        background: "white",
                                        padding: "8px",
                                        borderRadius: "50%"
                                    }} />
                                    <div>
                                        <div style={{ fontWeight: "600", color: "white", fontSize: "16px" }}>Revenus Passifs</div>
                                        <div style={{ color: "rgba(255,255,255,0.9)", fontSize: "15px" }}>Générez des revenus avec vos cours en ligne</div>
                                    </div>
                                </div>

                                {/* Processus */}
                                <div style={{ 
                                    display: "flex", 
                                    alignItems: "flex-start", 
                                    padding: "15px",
                                    background: "linear-gradient(135deg, #00b894 0%, #00cec9 100%)",
                                    borderRadius: "12px",
                                    boxShadow: "0 4px 15px rgba(0, 206, 201, 0.3)"
                                }}>
                                    <CheckCircleOutlined style={{ 
                                        fontSize: "24px", 
                                        color: "#00cec9", 
                                        marginRight: "15px",
                                        marginTop: "2px",
                                        background: "white",
                                        padding: "8px",
                                        borderRadius: "50%"
                                    }} />
                                    <div>
                                        <div style={{ fontWeight: "600", color: "white", fontSize: "16px" }}>Processus Simple</div>
                                        <div style={{ color: "rgba(255,255,255,0.9)", fontSize: "15px", lineHeight: "1.5" }}>
                                            1. Soumettez votre candidature<br/>
                                            2. Entretien avec notre équipe<br/>
                                            3. Créez votre premier cours<br/>
                                            4. Commencez à enseigner !
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Card>
                    </Col>

                    {/* Formulaire de Candidature */}
                    <Col xs={24} lg={14}>
                        <Card
                            style={{ 
                                borderRadius: "20px", 
                                boxShadow: "0 20px 60px rgba(0,0,0,0.15)",
                                border: "none",
                                overflow: "hidden"
                            }}
                        >
                            <div style={{
                                background: "linear-gradient(135deg, #2d6a4f 0%, #52b788 100%)",
                                margin: "-24px -24px 30px -24px",
                                padding: "30px 24px",
                                textAlign: "center"
                            }}>
                                <h2 style={{ 
                                    color: "white", 
                                    fontSize: "24px", 
                                    fontWeight: "600",
                                    margin: "0",
                                    textShadow: "0 2px 4px rgba(0,0,0,0.2)"
                                }}>
                                    📝 Candidature d'Instructeur
                                </h2>
                            </div>

                            {instructorSuccess && (
                                <div style={{
                                    padding: "20px",
                                    background: "linear-gradient(135deg, #00b894 0%, #00cec9 100%)",
                                    borderRadius: "12px",
                                    color: "white",
                                    textAlign: "center",
                                    marginBottom: "20px",
                                    fontWeight: "600",
                                    fontSize: "16px"
                                }}>
                                    ✅ Merci ! Votre candidature a été envoyée avec succès !
                                </div>
                            )}

                            <div style={{ marginBottom: "20px" }}>
                                <label style={labelStyle}>
                                    <UserOutlined style={{ marginRight: "5px", color: "#52b788" }} />
                                    Nom Complet <span style={{ color: "#e74c3c" }}>*</span>
                                </label>
                                <input
                                    style={{
                                        ...inputStyle,
                                        borderColor: instructorErrors.fullName ? "#e74c3c" : "#e1e8ed"
                                    }}
                                    value={instructorForm.fullName}
                                    onChange={(e) => update("fullName", e.target.value)}
                                    placeholder="Ex. Jean Dupont"
                                    onFocus={(e) => e.target.style.borderColor = "#52b788"}
                                    onBlur={(e) => e.target.style.borderColor = instructorErrors.fullName ? "#e74c3c" : "#e1e8ed"}
                                />
                                {instructorErrors.fullName && <div style={errorStyle}>{instructorErrors.fullName}</div>}
                            </div>

                            <div style={{ marginBottom: "20px" }}>
                                <label style={labelStyle}>
                                    <MailOutlined style={{ marginRight: "5px", color: "#52b788" }} />
                                    Adresse Email <span style={{ color: "#e74c3c" }}>*</span>
                                </label>
                                <input
                                    type="email"
                                    style={{
                                        ...inputStyle,
                                        borderColor: instructorErrors.email ? "#e74c3c" : "#e1e8ed"
                                    }}
                                    value={instructorForm.email}
                                    onChange={(e) => update("email", e.target.value)}
                                    placeholder="instructor@example.com"
                                    onFocus={(e) => e.target.style.borderColor = "#52b788"}
                                    onBlur={(e) => e.target.style.borderColor = instructorErrors.email ? "#e74c3c" : "#e1e8ed"}
                                />
                                {instructorErrors.email && <div style={errorStyle}>{instructorErrors.email}</div>}
                            </div>

                            <div style={{ marginBottom: "20px" }}>
                                <label style={labelStyle}>
                                    <PhoneOutlined style={{ marginRight: "5px", color: "#52b788" }} />
                                    Numéro de Téléphone <span style={{ color: "#e74c3c" }}>*</span>
                                </label>
                                <input
                                    style={{
                                        ...inputStyle,
                                        borderColor: instructorErrors.phone ? "#e74c3c" : "#e1e8ed"
                                    }}
                                    value={instructorForm.phone}
                                    onChange={(e) => update("phone", e.target.value)}
                                    placeholder="+212 6XX XXX XXX"
                                    onFocus={(e) => e.target.style.borderColor = "#52b788"}
                                    onBlur={(e) => e.target.style.borderColor = instructorErrors.phone ? "#e74c3c" : "#e1e8ed"}
                                />
                                {instructorErrors.phone && <div style={errorStyle}>{instructorErrors.phone}</div>}
                            </div>

                            <div style={{ marginBottom: "20px" }}>
                                <label style={labelStyle}>
                                    <BookOutlined style={{ marginRight: "5px", color: "#52b788" }} />
                                    Domaine d'Expertise <span style={{ color: "#e74c3c" }}>*</span>
                                </label>
                                <input
                                    style={{
                                        ...inputStyle,
                                        borderColor: instructorErrors.subject ? "#e74c3c" : "#e1e8ed"
                                    }}
                                    value={instructorForm.subject}
                                    onChange={(e) => update("subject", e.target.value)}
                                    placeholder="Ex. Développement Web, Marketing Digital, Design..."
                                    onFocus={(e) => e.target.style.borderColor = "#52b788"}
                                    onBlur={(e) => e.target.style.borderColor = instructorErrors.subject ? "#e74c3c" : "#e1e8ed"}
                                />
                                {instructorErrors.subject && <div style={errorStyle}>{instructorErrors.subject}</div>}
                            </div>

                            <div style={{ marginBottom: "30px" }}>
                                <label style={labelStyle}>
                                    <MessageOutlined style={{ marginRight: "5px", color: "#52b788" }} />
                                    Expérience et Motivation <span style={{ color: "#e74c3c" }}>*</span>
                                    <span style={{ color: "#636e72", fontSize: "12px", fontWeight: "400", marginLeft: "5px" }}>
                                        (minimum 50 caractères, {instructorForm.message.length}/2000)
                                    </span>
                                </label>
                                <textarea
                                    style={{
                                        ...inputStyle,
                                        minHeight: "120px",
                                        resize: "vertical",
                                        borderColor: instructorErrors.message ? "#e74c3c" : "#e1e8ed"
                                    }}
                                    value={instructorForm.message}
                                    onChange={(e) => update("message", e.target.value)}
                                    placeholder="Décrivez votre expérience professionnelle, vos qualifications, vos réalisations et votre motivation pour devenir formateur sur notre plateforme. Partagez avec nous votre parcours, vos compétences techniques, et ce qui vous passionne dans l'enseignement..."
                                    onFocus={(e) => e.target.style.borderColor = "#52b788"}
                                    onBlur={(e) => e.target.style.borderColor = instructorErrors.message ? "#e74c3c" : "#e1e8ed"}
                                />
                                {instructorErrors.message && <div style={errorStyle}>{instructorErrors.message}</div>}
                            </div>

                            <div style={{ textAlign: "center" }}>
                                <button
                                    onClick={submitInstructor}
                                    disabled={instructorLoading}
                                    style={{
                                        background: instructorLoading ? "#95a5a6" : "linear-gradient(135deg, #52b788 0%, #2d6a4f 100%)",
                                        color: "white",
                                        border: "none",
                                        borderRadius: "12px",
                                        padding: "15px 40px",
                                        fontSize: "16px",
                                        fontWeight: "600",
                                        cursor: instructorLoading ? "not-allowed" : "pointer",
                                        transition: "all 0.3s ease",
                                        boxShadow: "0 8px 25px rgba(82, 183, 136, 0.4)",
                                        display: "inline-flex",
                                        alignItems: "center",
                                        gap: "8px"
                                    }}
                                    onMouseEnter={(e) => {
                                        if (!instructorLoading) {
                                            e.currentTarget.style.transform = "translateY(-2px)";
                                            e.currentTarget.style.boxShadow = "0 12px 35px rgba(82, 183, 136, 0.6)";
                                        }
                                    }}
                                    onMouseLeave={(e) => {
                                        if (!instructorLoading) {
                                            e.currentTarget.style.transform = "translateY(0)";
                                            e.currentTarget.style.boxShadow = "0 8px 25px rgba(82, 183, 136, 0.4)";
                                        }
                                    }}
                                >
                                    {instructorLoading ? (
                                        <>
                                            <div style={{
                                                width: "16px",
                                                height: "16px",
                                                border: "2px solid rgba(255,255,255,0.3)",
                                                borderTop: "2px solid white",
                                                borderRadius: "50%",
                                                animation: "spin 1s linear infinite"
                                            }} />
                                            Envoi en cours...
                                        </>
                                    ) : (
                                        <>
                                            <SendOutlined />
                                            Soumettre ma Candidature
                                        </>
                                    )}
                                </button>
                            </div>

                            <div style={{ 
                                marginTop: "20px", 
                                textAlign: "center", 
                                fontSize: "14px", 
                                color: "#636e72",
                                lineHeight: "1.5"
                            }}>
                                En soumettant cette candidature, vous acceptez que nous traitions vos données 
                                pour évaluer votre demande d'instructeur.
                            </div>
                        </Card>
                    </Col>
                </Row>
            </div>

            <style jsx>{`
                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
            `}</style>
        </div>
    );
};

export default BecomeInstructor;